import React, { useCallback, useEffect, useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import SupervisorAccountOutlinedIcon from "@mui/icons-material/SupervisorAccountOutlined";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import mainLogo from "../../images/Main_logo.svg";
import hamburgerGreen from "../../images/hamburger-green.svg";
import hamburgerGrey from "../../images/hamburger-grey.svg";
import LogoCrop from "../../images/HOS-logo-crop.svg";
import Logout from "@mui/icons-material/Logout";

import {
  authHeader,
  getHamburgerMenu,
  getLogUserId,
  getLogUserRole,
  getLogUserRole1,
  getSideIndex,
} from "./MainFunction";
import {
  DASHBOARD_ROUTE,
  USERS_ROUTE,
  USER_LOG_ROUTE,
  CUSTOMERS_ROUTE,
  PROJECTS_ROUTE,
  DAILY_ENTRY_ROUTE,
  BILLING_STATEMENT_LIST_ROUTE,
  SIGNIN_ROUTE,
  ADMIN_BILLING_LIST,
  INVOICE_LIST,
  CUSTOMER_DETAILS,
  ADD_CUSTOMER,
  CUSTOMER_FILTER_MODEL,
  CUSTOMER_HISTORY,
  USER_FILTER_PROPERTIES,
  BILLING_REVIEW,
} from "../../constants/RoutePath";
import { useNavigate } from "react-router-dom";
import { deCryptFun, enCryptFun } from "./CustomFunction";
import { UPDATE_HAMBURGER_MENU_URL } from "../../constants/ApiRoute";
import API from "./API";
import { useDispatch, useSelector } from "react-redux";
// import { getLoggedUserDetails, getUserCheck } from "../../redux/action";
import { getLoggedUserDetails } from "../../redux/action";
import { useToast } from "./CustomMessages";
import {
  BILLING_STATEMENT_SELECT,
  PAGE_OFFSET,
  SORT_PARAMS,
} from "../../redux/action/ActionType";
import * as types from "../../redux/action/ActionType";
import {
  BillingIcon,
  CustomerIcon,
  DashboardIcon,
  DateIconSvg,
  InvoiceIcon,
  ManageUserIcon,
  ProjectIcon,
} from "../../images/SvgIcons";
import { filter } from "jszip";
import { CONSOLIDATE_INVOICE_LIST_INITIAL } from "../../redux/store/InitialStore";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";

const drawerWidth = 244;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));
const DrawerFooter = styled("div")(({ theme }) => ({
  // position: "fixed",
  alignItems: "left",
  // width: `calc(${drawerWidth}px - 10px)`,
  bottom: 0,
  margin: "0px 30px 20px 10px",
}));
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

// const location = useLocation();

export default function Sidebar(props) {
  const { higlightSide } = props;
  const theme = useTheme();
  const showToast = useToast();

  const [open, setOpen] = useState(
    parseInt(getHamburgerMenu()) === 1 ? true : false
  );
  const [opensubmenu, setOpensubmenu] = React.useState(false);
  const navigate = useNavigate();
  // const handleClick = () => {
  //   setOpensubmenu(!opensubmenu);
  // };
  const logoutChannel = new BroadcastChannel("logout-channel");
  const loginChannel = new BroadcastChannel("login-channel");
  const [freezePane, setFreezePane] = useState(
    parseInt(getHamburgerMenu()) === 1 ? true : false
  );
  const handleMouseEnter = () => {
    if (freezePane === true) return null;
    setOpen(true);
  };

  const changeStatus = useCallback(async (statuss) => {
    let data = {
      userId: getLogUserId(),
      hamburgerMenu: statuss,
    };
    const config = {
      method: "PUT",
      headers: authHeader(),
      url: UPDATE_HAMBURGER_MENU_URL,
      data: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (parsedResponse.status === "Success") {
        localStorage.setItem(
          "HamburgerMenu",
          enCryptFun((statuss === true ? 1 : 0).toString())
        );
      }
    } catch (error) {
      console.error(error);
    }
  }, []);
  const handleIconClick = () => {
    const newStatus = !freezePane;
    setFreezePane(newStatus);
    changeStatus(newStatus);
  };
  // const handleDrawerOpen = () => {
  //   setOpen(true);
  // };

  // const handleDrawerClose = () => {
  //   setOpen(false);
  // };

  const handleMouseLeave = () => {
    if (freezePane === true) return null;
    setOpen(false);
    // setOpensubmenu(false);
  };

  // useEffect(() => {
  //  changeStatus(freezePane)
  // }, [freezePane]);

  const roles = getLogUserRole1();

  const handleLogout = () => {
    logoutChannel.postMessage("logout");
    localStorage.clear();
    localStorage.setItem("logoutEvent", Date.now());
    localStorage.clear();
    window.dispatchEvent(new Event("storage"));
    dispatch({
      type: BILLING_STATEMENT_SELECT,
      payload: {
        userId: "",
        projectId: "",
        customerStatus: "",
        projectStatus: "",
        filterValues: {},
      },
    });
    dispatch({
      type: types.CONSOLIDATE_INVOICE_LIST_SELECT,
      payload: {
        matchedData: [],
        userList: [],
        invoiceAllSelectCheckbox: "",
        invoiceSingleCheckBox: "",
      },
    });
    dispatch({
      type: types.ADMIN_BILLING_STATEMENT_SELECT,
      payload: {
        userId: "",
        projectId: "",
        customerStatus: "",
        projectStatus: "",
        filterValues: {},
      },
    });
    dispatch({
      type: types.CUSTOMER_SELECT_LIST_FILTER,
      payload: {
        customer: [],
        customerStatus: "",
        billingDefaultDayRate: "",
        billingDefaultperiod: "",
        customerStatusActive: "",
        page: 0,
      },
    });
    dispatch({
      type: types.INVOICE_LIST_SELECT,
      payload: {
        customerStatus: "",
        projectStatus: "",
        userId: "",
        projectId: "",
        filter: {
          billingStartDateDatepicker: "",
          billingEndDateDatepicker: "",
          billingStartDate: "",
          billingEndDate: "",
          invoiceStatus: "",
        },
      },
    });
    navigate(SIGNIN_ROUTE);
  };

  // useEffect(() => {
  //   const onStorageChange = (event) => {
  //     if (event.key === "logoutEvent") {
  //       localStorage.clear()

  //       navigate(SIGNIN_ROUTE);
  //     }
  //   };

  //   window.addEventListener("storage", onStorageChange);

  //   return () => {
  //     window.removeEventListener("storage", onStorageChange);
  //   };
  // }, [navigate]);

  const dispatch = useDispatch();
  // user deactive session out

  const isActive = useSelector((s) => s.ActiveUserReducer);
  console.log(isActive, "isActiveeeeeeeeeeee");
  // let val = isActive && JSON.parse(isActive);
  let time = localStorage.getItem("API_TIME");

  // const checkUser = deCryptFun(useSelector((s) => s.CheckUserReducer));

  // useEffect(() => {
  //   if (checkUser) {
  //     let checkUserParse = JSON.parse(checkUser);
  //     if (
  //       checkUserParse &&
  //       checkUserParse.type &&
  //       checkUserParse.type == "error"
  //     ) {
  //       showToast(checkUserParse.message, "error");
  //      // handleLogout();
  //     }
  //   }
  // }, [checkUser]);

  useEffect(() => {
    dispatch(getLoggedUserDetails());
    // dispatch(getUserCheck());
  }, [dispatch]);
  useEffect(() => {
    if (isActive?.userId == getLogUserId() && isActive?.isActive == 0) {
      showToast("Your account has been deactivated by the admin.", "error");
      handleLogout();
      // navigate("/signin")
    }
  }, [navigate, isActive.isActive, time]);

  useEffect(() => {
    const pathToIndexMap = {
      [DASHBOARD_ROUTE]: "0",
      [CUSTOMERS_ROUTE]: "1",
      [PROJECTS_ROUTE]: "2",
      [DAILY_ENTRY_ROUTE]: "7",
      [BILLING_REVIEW]: "4",
      [INVOICE_LIST]: "5",
      [USERS_ROUTE]: "6",
    };

    const billingRoutes = [BILLING_STATEMENT_LIST_ROUTE, ADMIN_BILLING_LIST];
    if (billingRoutes.some((route) => location.pathname.includes(route))) {
      if (!roles.includes("Admin") && roles.includes("Broker")) {
        localStorage.setItem("LOG_SIDE_INDEX", "0");
      } else if (
        (roles.includes("Admin") && roles.includes("Broker")) ||
        roles.includes("Admin")
      ) {
        localStorage.setItem("LOG_SIDE_INDEX", "3");
      } else {
        localStorage.setItem("LOG_SIDE_INDEX", "3");
      }
    } else {
      const index = Object.keys(pathToIndexMap).find((path) =>
        location.pathname.includes(path)
      );
      if (index) {
        localStorage.setItem("LOG_SIDE_INDEX", pathToIndexMap[index]);
      }
    }
  }, [location.pathname, roles]);

  return (
    <div
      className="main-sidebar"
      style={{ backgroundColor: "red !important" }}
      onMouseEnter={() => handleMouseEnter()}
      onMouseLeave={() => handleMouseLeave()}
    >
      <CssBaseline />
      <AppBar
        position="fixed"
        open={open}
        style={{
          boxShadow: "none",
          // width: "0",
          // left: "0",
        }}
      ></AppBar>
      <Drawer variant="permanent" open={open}>
        {open ? (
          <DrawerHeader style={{ justifyContent: "flex-start" }}>
            <img
              src={mainLogo}
              style={{
                marginRight: "10px",
                // maxWidth: "150px",
                overflow: "hidden",
                marginLeft: "10px",
              }}
              alt="Tlogo-dup"
            ></img>
            <IconButton
              sx={{
                "&:hover": { backgroundColor: "transparent !important" },
                pr: "4px",
              }}
              onClick={handleIconClick}
            >
              <img
                style={{
                  background: freezePane
                    ? "rgba(72, 158, 146, 0.1)"
                    : "#EEF6ED",
                  color: "white",
                  opacity: "1",
                  borderRadius: "6px",
                  padding: "6px",
                  height: "35px",
                  width: "35px",
                  maxWidth: "35px",
                  overflow: "hidden",
                }}
                src={freezePane ? hamburgerGreen : hamburgerGrey}
                alt="SidebarIconl"
              />
            </IconButton>
          </DrawerHeader>
        ) : (
          <DrawerHeader sx={{ maxWidth: "65px", maxHeight: "40px" }}>
            <img
              // src={Clogo}
              src={LogoCrop}
              style={{
                marginRight: "10px",
                // width: "32px",
                // maxWidth: "32px",
                // width: "150px",
                position: "absolute",
                left: "12px",
                overflow: "hidden",
              }}
              alt="Tlogo-dup"
            ></img>
          </DrawerHeader>
        )}
        <List
          className="sidebar"
          sx={{ mt: 5.5 }}
          // style={settingState ? { pointerEvents: "none" } : {}}
        >
          {roles.includes("Admin") && (
            <ListItem disablePadding sx={{ display: "block" }}>
              <ListItemButton
                className={
                  higlightSide == "0" ? "menu-list1 active" : "menu-list1"
                }
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
                onClick={() => {
                  dispatch({
                    type: PAGE_OFFSET,
                    payload: 0,
                  });
                  dispatch({
                    type: SORT_PARAMS,
                    payload: { order: "", orderBy: "" },
                  });
                  dispatch({
                    type: BILLING_STATEMENT_SELECT,
                    payload: {
                      userId: "",
                      projectId: "",
                      customerStatus: "",
                      projectStatus: "",
                      filterValues: {},
                    },
                  });
                  dispatch({
                    type: types.CONSOLIDATE_INVOICE_LIST_SELECT,
                    payload: {
                      matchedData: [],
                      userList: [],
                      invoiceAllSelectCheckbox: "",
                      invoiceSingleCheckBox: "",
                    },
                  });
                  dispatch({
                    type: types.ADMIN_BILLING_STATEMENT_SELECT,
                    payload: {
                      userId: "",
                      projectId: "",
                      customerStatus: "",
                      projectStatus: "",
                      filterValues: {},
                    },
                  });
                  dispatch({
                    type: types.CUSTOMER_SELECT_LIST_FILTER,
                    payload: {
                      customer: [],
                      customerStatus: "",
                      billingDefaultDayRate: "",
                      billingDefaultperiod: "",
                      customerStatusActive: "",
                      page: 0,
                    },
                  });
                  dispatch({
                    type: types.INVOICE_LIST_SELECT,
                    payload: {
                      customerStatus: "",
                      projectStatus: "",
                      userId: "",
                      projectId: "",
                      filter: {
                        billingStartDateDatepicker: "",
                        billingEndDateDatepicker: "",
                        billingStartDate: "",
                        billingEndDate: "",
                        invoiceStatus: "",
                      },
                    },
                  });
                  navigate("/dashboard");
                  if (roles.includes("Admin")) {
                    localStorage.setItem("LOG_SIDE_INDEX", "0");
                  }
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  {/* <img
                    className="sidebar_icon_image"
                    style={{
                      background: "#5bc4dd26",
                      opacity: "1",
                      borderRadius: "6px",
                      padding: "5px",
                    }}
                    src={DashboardIcon}
                    alt="Dashboard"
                  /> */}
                  <DashboardIcon />
                </ListItemIcon>
                <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                  Dashboard
                </ListItemText>
              </ListItemButton>
            </ListItem>
          )}
          {roles.includes("Admin") && (
            <>
              <ListItem disablePadding sx={{ display: "block" }}>
                <ListItemButton
                  className={
                    // location.pathname.toString().includes(CUSTOMERS_ROUTE) ||
                    // location.pathname.toString().includes(CUSTOMER_HISTORY) ||
                    // location.pathname
                    //   .toString()
                    //   .includes(CUSTOMER_FILTER_MODEL) ||
                    // (location.pathname.toString().includes(ADD_CUSTOMER) ||
                    //   getSideIndex() == "1")
                    higlightSide == "1" ? "menu-list1 active" : "menu-list1"
                  }
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                  onClick={() => {
                    dispatch({
                      type: PAGE_OFFSET,
                      payload: 0,
                    });
                    dispatch({
                      type: SORT_PARAMS,
                      payload: { order: "", orderBy: "" },
                    });
                    navigate("/customers");
                    if (roles.includes("Admin")) {
                      localStorage.setItem("LOG_SIDE_INDEX", "1");
                    }
                    dispatch({
                      type: BILLING_STATEMENT_SELECT,
                      payload: {
                        userId: "",
                        projectId: "",
                        customerStatus: "",
                        projectStatus: "",
                        filterValues: {},
                      },
                    });
                    dispatch({
                      type: types.CONSOLIDATE_INVOICE_LIST_SELECT,
                      payload: {
                        matchedData: [],
                        userList: [],
                        invoiceAllSelectCheckbox: "",
                        invoiceSingleCheckBox: "",
                      },
                    });
                    dispatch({
                      type: types.ADMIN_BILLING_STATEMENT_SELECT,
                      payload: {
                        userId: "",
                        projectId: "",
                        customerStatus: "",
                        projectStatus: "",
                        filterValues: {},
                      },
                    });
                    dispatch({
                      type: types.CUSTOMER_SELECT_LIST_FILTER,
                      payload: {
                        customer: [],
                        customerStatus: "",
                        billingDefaultDayRate: "",
                        billingDefaultperiod: "",
                        customerStatusActive: "",
                        page: 0,
                      },
                    });
                    dispatch({
                      type: types.INVOICE_LIST_SELECT,
                      payload: {
                        customerStatus: "",
                        projectStatus: "",
                        userId: "",
                        projectId: "",
                        filter: {
                          billingStartDateDatepicker: "",
                          billingEndDateDatepicker: "",
                          billingStartDate: "",
                          billingEndDate: "",
                          invoiceStatus: "",
                        },
                      },
                    });
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <CustomerIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                    Customers
                  </ListItemText>
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding sx={{ display: "block" }}>
                <ListItemButton
                  className={
                    location.pathname.toString().includes(PROJECTS_ROUTE) ||
                    higlightSide == "2"
                      ? "menu-list1 active"
                      : "menu-list1"
                  }
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                  onClick={() => {
                    dispatch({
                      type: PAGE_OFFSET,
                      payload: 0,
                    });
                    dispatch({
                      type: SORT_PARAMS,
                      payload: { order: "", orderBy: "" },
                    });
                    navigate(PROJECTS_ROUTE);
                    if (roles.includes("Admin")) {
                      localStorage.setItem("LOG_SIDE_INDEX", "2");
                    }
                    dispatch({
                      type: BILLING_STATEMENT_SELECT,
                      payload: {
                        userId: "",
                        projectId: "",
                        customerStatus: "",
                        projectStatus: "",
                        filterValues: {},
                      },
                    });
                    dispatch({
                      type: types.CONSOLIDATE_INVOICE_LIST_SELECT,
                      payload: {
                        matchedData: [],
                        userList: [],
                        invoiceAllSelectCheckbox: "",
                        invoiceSingleCheckBox: "",
                      },
                    });
                    dispatch({
                      type: types.ADMIN_BILLING_STATEMENT_SELECT,
                      payload: {
                        userId: "",
                        projectId: "",
                        customerStatus: "",
                        projectStatus: "",
                        filterValues: {},
                      },
                    });
                    dispatch({
                      type: types.CUSTOMER_SELECT_LIST_FILTER,
                      payload: {
                        customer: [],
                        customerStatus: "",
                        billingDefaultDayRate: "",
                        billingDefaultperiod: "",
                        customerStatusActive: "",
                        page: 0,
                      },
                    });
                    dispatch({
                      type: types.INVOICE_LIST_SELECT,
                      payload: {
                        customerStatus: "",
                        projectStatus: "",
                        userId: "",
                        projectId: "",
                        filter: {
                          billingStartDateDatepicker: "",
                          billingEndDateDatepicker: "",
                          billingStartDate: "",
                          billingEndDate: "",
                          invoiceStatus: "",
                        },
                      },
                    });
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <ProjectIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                    Projects
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </>
          )}

          {roles.includes("Broker") && (
            <>
              <ListItem disablePadding sx={{ display: "block" }}>
                <ListItemButton
                  className={
                    location.pathname.toString().includes(DAILY_ENTRY_ROUTE) ||
                    higlightSide == "7"
                      ? "menu-list1 active"
                      : "menu-list1"
                  }
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                  onClick={() => {
                    dispatch({
                      type: PAGE_OFFSET,
                      payload: 0,
                    });
                    dispatch({
                      type: SORT_PARAMS,
                      payload: { order: "", orderBy: "" },
                    });
                    navigate(DAILY_ENTRY_ROUTE);
                    if (roles.includes("Admin")) {
                      localStorage.setItem("LOG_SIDE_INDEX", "7");
                    }
                    dispatch({
                      type: BILLING_STATEMENT_SELECT,
                      payload: {
                        userId: "",
                        projectId: "",
                        customerStatus: "",
                        projectStatus: "",
                        filterValues: {},
                      },
                    });
                    dispatch({
                      type: types.CONSOLIDATE_INVOICE_LIST_SELECT,
                      payload: {
                        matchedData: [],
                        userList: [],
                        invoiceAllSelectCheckbox: "",
                        invoiceSingleCheckBox: "",
                      },
                    });
                    dispatch({
                      type: types.ADMIN_BILLING_STATEMENT_SELECT,
                      payload: {
                        userId: "",
                        projectId: "",
                        customerStatus: "",
                        projectStatus: "",
                        filterValues: {},
                      },
                    });
                    dispatch({
                      type: types.CUSTOMER_SELECT_LIST_FILTER,
                      payload: {
                        customer: [],
                        customerStatus: "",
                        billingDefaultDayRate: "",
                        billingDefaultperiod: "",
                        customerStatusActive: "",
                        page: 0,
                      },
                    });
                    dispatch({
                      type: types.INVOICE_LIST_SELECT,
                      payload: {
                        customerStatus: "",
                        projectStatus: "",
                        userId: "",
                        projectId: "",
                        filter: {
                          billingStartDateDatepicker: "",
                          billingEndDateDatepicker: "",
                          billingStartDate: "",
                          billingEndDate: "",
                          invoiceStatus: "",
                        },
                      },
                    });
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <DateIconSvg />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                    Daily Entry
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </>
          )}

          <ListItem disablePadding sx={{ display: "block" }}>
            <ListItemButton
              className={
                location.pathname.includes(BILLING_STATEMENT_LIST_ROUTE) ||
                // (location.pathname.includes(ADMIN_BILLING_LIST) &&
                (!roles.includes("Admin") &&
                  roles.includes("Broker") &&
                  higlightSide == "0") ||
                (roles.includes("Admin") &&
                  roles.includes("Broker") &&
                  higlightSide == "3") ||
                (roles.includes("Admin") && higlightSide == "3")
                  ? "menu-list1 active"
                  : "menu-list1"
              }
              sx={{
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
              onClick={() => {
                dispatch({
                  type: PAGE_OFFSET,
                  payload: 0,
                });
                dispatch({
                  type: SORT_PARAMS,
                  payload: { order: "", orderBy: "" },
                });
                roles.includes("Broker")
                  ? navigate(BILLING_STATEMENT_LIST_ROUTE)
                  : navigate(ADMIN_BILLING_LIST);
                dispatch({
                  type: BILLING_STATEMENT_SELECT,
                  payload: {
                    userId: "",
                    projectId: "",
                    customerStatus: "",
                    projectStatus: "",
                    filterValues: {},
                  },
                });
                dispatch({
                  type: types.CONSOLIDATE_INVOICE_LIST_SELECT,
                  payload: {
                    matchedData: [],
                    userList: [],
                    invoiceAllSelectCheckbox: "",
                    invoiceSingleCheckBox: "",
                  },
                });
                dispatch({
                  type: types.ADMIN_BILLING_STATEMENT_SELECT,
                  payload: {
                    userId: "",
                    projectId: "",
                    customerStatus: "",
                    projectStatus: "",
                    filterValues: {},
                  },
                });
                dispatch({
                  type: types.INVOICE_LIST_SELECT,
                  payload: {
                    customerStatus: "",
                    projectStatus: "",
                    userId: "",
                    projectId: "",
                    filter: {
                      billingStartDateDatepicker: "",
                      billingEndDateDatepicker: "",
                      billingStartDate: "",
                      billingEndDate: "",
                      invoiceStatus: "",
                    },
                  },
                });
                dispatch({
                  type: types.CUSTOMER_SELECT_LIST_FILTER,
                  payload: {
                    customer: [],
                    customerStatus: "",
                    billingDefaultDayRate: "",
                    billingDefaultperiod: "",
                    customerStatusActive: "",
                    page: 0,
                  },
                });
                if (roles.includes("Admin")) {
                  localStorage.setItem("LOG_SIDE_INDEX", "3");
                } else {
                  localStorage.setItem("LOG_SIDE_INDEX", "0");
                }
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <BillingIcon />
              </ListItemIcon>
              <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                Billing Statements
              </ListItemText>
            </ListItemButton>
          </ListItem>
          {/* {roles.includes("Admin") ? (
            <ListItem disablePadding sx={{ display: "block" }}>
              <ListItemButton
                className={
                  location.pathname.toString().includes(ADMIN_BILLING_LIST)
                    ? "menu-list1 active"
                    : "menu-list1"
                }
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
                onClick={() => {
                  navigate("/adminbillingstatement");
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <span class="material-symbols-outlined">receipt_long</span>
                </ListItemIcon>
                <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                  Billing Statements(O)
                </ListItemText>
              </ListItemButton>
            </ListItem>
          ) : (
            <></>
          )} */}

          {roles.includes("Admin") && (
            <>
              <ListItem disablePadding sx={{ display: "block" }}>
                {/* <NavLink
              to={BILLING_REVIEW}
              style={{ textDecoration: "none", color: "inherit" }}
            > */}
                <ListItemButton
                  className={
                    location.pathname.toString().includes(BILLING_REVIEW) ||
                    higlightSide === "4"
                      ? "menu-list1 active"
                      : "menu-list1"
                  }
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                  onClick={() => {
                    dispatch({
                      type: PAGE_OFFSET,
                      payload: 0,
                    });
                    dispatch({
                      type: SORT_PARAMS,
                      payload: { order: "", orderBy: "" },
                    });
                    navigate(BILLING_REVIEW);
                    if (roles.includes("Admin")) {
                      localStorage.setItem("LOG_SIDE_INDEX", "4");
                    }
                    dispatch({
                      type: BILLING_STATEMENT_SELECT,
                      payload: {
                        userId: "",
                        projectId: "",
                        customerStatus: "",
                        projectStatus: "",
                        filterValues: {},
                      },
                    });
                    dispatch({
                      type: types.CONSOLIDATE_INVOICE_LIST_SELECT,
                      payload: {
                        matchedData: [],
                        userList: [],
                        invoiceAllSelectCheckbox: "",
                        invoiceSingleCheckBox: "",
                      },
                    });
                    dispatch({
                      type: types.ADMIN_BILLING_STATEMENT_SELECT,
                      payload: {
                        userId: "",
                        projectId: "",
                        customerStatus: "",
                        projectStatus: "",
                        filterValues: {},
                      },
                    });
                    dispatch({
                      type: types.CUSTOMER_SELECT_LIST_FILTER,
                      payload: {
                        customer: [],
                        customerStatus: "",
                        billingDefaultDayRate: "",
                        billingDefaultperiod: "",
                        customerStatusActive: "",
                        page: 0,
                      },
                    });
                    dispatch({
                      type: types.INVOICE_LIST_SELECT,
                      payload: {
                        customerStatus: "",
                        projectStatus: "",
                        userId: "",
                        projectId: "",
                        filter: {
                          billingStartDateDatepicker: "",
                          billingEndDateDatepicker: "",
                          billingStartDate: "",
                          billingEndDate: "",
                          invoiceStatus: "",
                        },
                      },
                    });
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <AssignmentTurnedInOutlinedIcon
                      sx={{ color: "rgb(33 33 33)" }}
                    />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                    Billing Review
                  </ListItemText>
                </ListItemButton>
                {/* </NavLink> */}
              </ListItem>
            </>
          )}
          {roles.includes("Admin") && (
            <>
              <ListItem disablePadding sx={{ display: "block" }}>
                <ListItemButton
                  className={
                    location.pathname.toString().includes(INVOICE_LIST) ||
                    higlightSide == "5"
                      ? "menu-list1 active"
                      : "menu-list1"
                  }
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                  onClick={() => {
                    dispatch({
                      type: PAGE_OFFSET,
                      payload: 0,
                    });
                    dispatch({
                      type: SORT_PARAMS,
                      payload: { order: "", orderBy: "" },
                    });
                    navigate("/invoices");
                    if (roles.includes("Admin")) {
                      localStorage.setItem("LOG_SIDE_INDEX", "5");
                    }
                    dispatch({
                      type: BILLING_STATEMENT_SELECT,
                      payload: {
                        userId: "",
                        projectId: "",
                        customerStatus: "",
                        projectStatus: "",
                        filterValues: {},
                      },
                    });
                    dispatch({
                      type: types.CONSOLIDATE_INVOICE_LIST_SELECT,
                      payload: {
                        matchedData: [],
                        userList: [],
                        invoiceAllSelectCheckbox: "",
                        invoiceSingleCheckBox: "",
                      },
                    });
                    dispatch({
                      type: types.ADMIN_BILLING_STATEMENT_SELECT,
                      payload: {
                        userId: "",
                        projectId: "",
                        customerStatus: "",
                        projectStatus: "",
                        filterValues: {},
                      },
                    });
                    dispatch({
                      type: types.CUSTOMER_SELECT_LIST_FILTER,
                      payload: {
                        customer: [],
                        customerStatus: "",
                        billingDefaultDayRate: "",
                        billingDefaultperiod: "",
                        customerStatusActive: "",
                        page: 0,
                      },
                    });
                    dispatch({
                      type: types.INVOICE_LIST_SELECT,
                      payload: {
                        customerStatus: "",
                        projectStatus: "",
                        userId: "",
                        projectId: "",
                        filter: {
                          billingStartDateDatepicker: "",
                          billingEndDateDatepicker: "",
                          billingStartDate: "",
                          billingEndDate: "",
                          invoiceStatus: "",
                        },
                      },
                    });
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <InvoiceIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                    Invoices
                  </ListItemText>
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding sx={{ display: "block" }}>
                <ListItemButton
                  className={
                    // location.pathname.toString().includes(USERS_ROUTE) ||
                    higlightSide == "6" ? "menu-list1 active" : "menu-list1"
                  }
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                  onClick={() => {
                    dispatch({
                      type: PAGE_OFFSET,
                      payload: 0,
                    });
                    dispatch({
                      type: SORT_PARAMS,
                      payload: { order: "", orderBy: "" },
                    });
                    navigate("/users");
                    if (roles.includes("Admin")) {
                      localStorage.setItem("LOG_SIDE_INDEX", "6");
                    }
                    dispatch({
                      type: BILLING_STATEMENT_SELECT,
                      payload: {
                        userId: "",
                        projectId: "",
                        customerStatus: "",
                        projectStatus: "",
                        filterValues: {},
                      },
                    });
                    dispatch({
                      type: types.CONSOLIDATE_INVOICE_LIST_SELECT,
                      payload: {
                        CONSOLIDATE_INVOICE_LIST_INITIAL,
                      },
                    });
                    dispatch({
                      type: types.ADMIN_BILLING_STATEMENT_SELECT,
                      payload: {
                        userId: "",
                        projectId: "",
                        customerStatus: "",
                        projectStatus: "",
                        filterValues: {},
                      },
                    });
                    dispatch({
                      type: types.CUSTOMER_SELECT_LIST_FILTER,
                      payload: {
                        customer: [],
                        customerStatus: "",
                        billingDefaultDayRate: "",
                        billingDefaultperiod: "",
                        customerStatusActive: "",
                        page: 0,
                      },
                    });
                    dispatch({
                      type: types.INVOICE_LIST_SELECT,
                      payload: {
                        customerStatus: "",
                        projectStatus: "",
                        userId: "",
                        projectId: "",
                        filter: {
                          billingStartDateDatepicker: "",
                          billingEndDateDatepicker: "",
                          billingStartDate: "",
                          billingEndDate: "",
                          invoiceStatus: "",
                        },
                      },
                    });
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <ManageUserIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                    Manage Users
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </>
          )}
        </List>
        <DrawerFooter
          className="logout-menu"
          sx={{ margin: "0px 30px 15px 5px", mt: "auto" }}
        >
          <List
          // sx={{ position: "fixed", bottom: "13%" }}
          >
            <ListItem disablePadding sx={{ display: "block" }}>
              <ListItemButton
                className={"menu-list1"}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
                onClick={handleLogout}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Logout sx={{ color: "#000000" }} fontSize="small" />
                </ListItemIcon>
                <ListItemText sx={{ opacity: open ? 1 : 0, color: "#212121" }}>
                  Logout
                </ListItemText>
              </ListItemButton>
            </ListItem>
          </List>
        </DrawerFooter>
      </Drawer>
    </div>
  );
}
